import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./LoginForm.css";
import sensen_Login_Image from "../Assets/sensen_Login_Image.png";
import { APP_SERVICES_URL } from "../Constant/constant";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setEmailError(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    // Validate email before submitting
    if (!email) {
      setEmailError(true);
      return;
    }

    try {
      const response = await fetch(
        `${APP_SERVICES_URL}/sn-auth-service/resetPasswordMail?email=${encodeURIComponent(
          email
        )}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        setLoading(false);
        // Success: Navigate to the success page
        navigate(
          `/scancam-edge/resetpasswordsuccess?email=${encodeURIComponent(
            email
          )}`
        );
      } else {
        // Error: Display an error message
        setLoading(false);
        console.error("Error:", response.statusText);
        // You can handle the error as needed, such as displaying an error message to the user.
      }
    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
      // Handle network errors or other unexpected issues
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <form method="post" onSubmit={handleSubmit} className="login-form">
          <div className="login-form-container">
            <div className="login-header-forgot-Password">
              <img
                src={sensen_Login_Image}
                alt="logoSensen"
                height={52}
                width={168}
              />
              <h1 className="welcome-heading">Forgot Your Password?</h1>
              <p className="welcome-text">
                Enter your email address and we will send you instructions to
                reset your password.
              </p>
            </div>
            <div className="login-input-container">
              <div className="login-input-wrapper">
                <label htmlFor="email" className="input-label">
                  Email
                </label>
                <input
                  type="text"
                  id="email"
                  name="email"
                  value={email}
                  onChange={handleEmailChange}
                  required
                  className="input-field"
                />
              </div>
            </div>
            <div className="login-actions">
              <button
                type="submit"
                disabled={loading}
                className="submit-button"
              >
                {loading ? (
                  <svg
                    className="loading-spinner"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="spinner-circle"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="spinner-path"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v8H4z"
                    ></path>
                  </svg>
                ) : (
                  "Continue"
                )}
              </button>
              <Link className="back-button" to={"/scancam-edge"}>
                Back to login page
              </Link>
            </div>
          </div>
        </form>
      </div>
    </div>
    // <div className="page-container showNormalFont">
    //     {
    //         showBackdrop && <Backdrop
    //             sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
    //             open={showBackdrop}
    //             onClick={() => { }}
    //         >
    //             <CircularProgress color="inherit" />
    //         </Backdrop>
    //     }
    //     <form className="content-container" onSubmit={handleSubmit}>
    //         <div className="login-header w-100 ">
    //             <img src={sensen_Login_Image} alt="Logo" className="forgotpassword-form-logo" />
    //             <div className="forgotPassword-form-title">
    //                 <h1>Forgot Your Password?</h1>
    //             </div>
    //             <h2 className="forgotPassword-form-subtitle text-center pt-0" >
    //                 Enter your email address and we will send you instructions to reset your password
    //             </h2>
    //         </div>

    //         <div className="login-body w-100">
    //             <div className="inputContainer w-100">
    //                 <div className="form-floating w-100">
    //                     <FormControl fullWidth variant="outlined">
    //                         <p >Email address</p>
    //                         <TextField
    //                             id="outlined-basic"
    //                             type="email"
    //                             className={`inputField mb-4 ${emailError ? "inputError " : "passwordInput"}`}
    //                             value={email}
    //                             onChange={handleEmailChange}
    //                             fullWidth
    //                             required
    //                         />
    //                     </FormControl>
    //                 </div>
    //                 {emailError && (
    //                     <p className="form-errorMessage">
    //                         Above field is mandatory to be filled
    //                     </p>
    //                 )}
    //             </div>
    //             <button className="continueButton" type="submit">
    //                 Continue
    //             </button>
    //             <Link to="/scancam-edge" className="mt-4 back-button">
    //                 Back to Scancam Portal
    //             </Link>
    //         </div>
    //     </form>
    // </div>
  );
};

export default ForgotPassword;
